export const PROMPT_TEMPLATES_VARIABLES = {
  product_url: '{{product_url}}',
};

export const PROMPT_TEMPLATES = [
  {
    icon: 'mdi-magnify',
    label: 'Phân tích sản phẩm & gợi ý concept ảnh chạy Facebook Ads',
    prompt: `
     +quick ${PROMPT_TEMPLATES_VARIABLES.product_url}
    `,
  },
  // {
  //   icon: 'mdi-magnify',
  //   label: 'Phân tích sản phẩm & gợi ý 10 concept ảnh chạy FB Ads',
  //   prompt: `
  //     Đây là sản phẩm của tôi: ${PROMPT_TEMPLATES_VARIABLES.product_url} \n\nHãy đóng vai 1 chuyên gia dropship với hơn 10 năm kinh nghiệm bán tại thị trường Mỹ, hãy phân tích sản phẩm trên thật kỹ. Liệt kê description và selling points của sản phẩm trên.\n\nTừ description và selling points trên hãy cho tôi 10 concept để tạo ảnh chạy ads facebook. Để CTR cao và tỉ lệ chuyển đổi cao. Phù hợp với tệp đối tượng tiềm năng mà đã phân tích.
  //   `,
  // },
  // {
  //   icon: 'mdi-image-outline',
  //   label: 'Tạo ảnh theo concept',
  //   prompt: `
  //     Giờ hãy tạo cho tôi ảnh theo concept ABC/XYZ. Tỉ lệ ảnh 1:1, text rõ ràng dễ hiểu, đúng chính tả ngữ pháp. Màu sắc hài hòa dễ nhìn phù hợp tệp đối tượng. Nhấn mạnh thể hiện rõ phần giá chỉ $19.95, có CTA SHOP NOW.
  //   `,
  // },
];
